import {createSlice} from '@reduxjs/toolkit';

export const initialState = {
  openFilters: false,
  filters: {
    sort: 'date_from:0',
  },
  limit: 25,
  page: 1,
  total: 0,
};

export const propertySlice = createSlice({
  name: 'property',
  initialState,
  reducers: {
    setFilters: (state, {payload}) => ({
      ...state,
      filters: {
        ...state.filters,
        ...payload,
      },
    }),
    resetFilters: (state, {payload = null}) => {
      if (payload) {
        return {
          ...state,
          filters: {
            ...state.filters,
            ...payload,
          },
        };
      }
      return {
        ...state,
        filters: initialState.filters,
      };
    },
    clearFilterKeys: (state, {payload: keys = []}) => {
      const next = {...state.filters};
      // eslint-disable-next-line fp/no-delete
      keys.forEach(k => delete next[k]);
      return {
        ...state,
        filters: next,
      };
    },
    setOpenFilters: (state, {payload}) => ({
      ...state,
      openFilters: payload,
    }),
    setPage: (state, {payload}) => ({
      ...state,
      page: payload,
    }),
    setLimit: (state, {payload}) => ({
      ...state,
      page: 1,
      limit: payload,
    }),
    setTotal: (state, {payload}) => ({
      ...state,
      total: payload,
    }),
  },
});

export const propertyState = state => state.property;

export const {
  setFilters,
  resetFilters,
  clearFilterKeys,
  setOpenFilters,
  setPage,
  setLimit,
  setTotal,
} = propertySlice.actions;

export default propertySlice.reducer;
